module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/icon_plan-852a4544ca5abb8d2ed98311894d690c.png";